import React from 'react'
import Button from 'components/Common/Button'
import { BUTTON_VARIANT } from 'utils/constants'
import { useSelector } from 'react-redux'
import HtmlParser from 'react-html-parser'
import './styles/index.scss'

const ConfirmSignupCancellation = ({ onPrimaryClick, onSecondaryClick }) => {
  const { languageData } = useSelector((state) => state.language)

  return (
    <div className='confirm-signup-cancellation'>
      <img src={`${process.env.REACT_APP_STATIC_IMAGE}/signup-cancellation-banner.png`} alt='Confirm Signup Cancellation' className='csc-banner' />

      <div className='csc-content'>
        <h2 className='csc-title'>
          {languageData?.signupCancelModalTitle && HtmlParser(languageData?.signupCancelModalTitle)}
        </h2>
        <p className='csc-subtext'>
          {languageData?.signupCancelModalSubtext}
        </p>

        <div className='csc-actions'>
          <Button
            variant={BUTTON_VARIANT.SECONDARY}
            className='csc-primary-btn'
            onClick={onPrimaryClick}
            type='button'
          >
            {languageData?.signupCancelModalPrimaryButtonText}
          </Button>
          <Button
            variant={BUTTON_VARIANT.TERTIARY}
            className='csc-secondary-btn'
            onClick={onSecondaryClick}
            type='button'
          >
            {languageData?.signupCancelModalSecondaryButtonText}
          </Button>
        </div>
      </div>
    </div>
  )
}

export default ConfirmSignupCancellation
